// extracted by mini-css-extract-plugin
export const root = "links-block-module--root--SKT3W";
export const item = "links-block-module--item--jxDIA";